import {
  Activity,
  Calendar,
  ClipboardCheck,
  ClipboardList,
  ClipboardPen,
  FileText,
  FlaskConical,
  HeartHandshake,
  House,
  ListChecks,
  PillBottle,
  ShieldCheck,
  Stethoscope,
  TriangleAlert,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { DataResource } from './types';

export const RESOURCE_ICONS: Record<DataResource, LucideIcon> = {
  careTeam: HeartHandshake,
  conditions: ListChecks,
  documents: FileText,
  medications: PillBottle,
  allergies: TriangleAlert,
  immunizations: ShieldCheck,
  labs: FlaskConical,
  vitals: Activity,
  encounters: Calendar,
  procedures: Stethoscope,
  familyHistory: Users,
  socialHistory: House,
  surveys: ClipboardPen,
  serviceRequests: ClipboardList,
  labOrders: ClipboardCheck,
};
